/**
 * @fileoverview DELETE handler for the "/:app_group_id/figma/oauth/disconnect" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { deleteAppGroupIdFigmaOauthDisconnectCacheKeys } from "./constants";
import type {
  DeleteAppGroupIdFigmaOauthDisconnectProps,
  DeleteAppGroupIdFigmaOauthDisconnectResult,
} from "./types";

export const deleteAppGroupIdFigmaOauthDisconnect = reactQueryMutationAdapter(
  deleteAppGroupIdFigmaOauthDisconnectCacheKeys,
  (props: DeleteAppGroupIdFigmaOauthDisconnectProps): Promise<DeleteAppGroupIdFigmaOauthDisconnectResult> => {
    return fetch(`/${props.appGroupId}/figma/oauth/disconnect`, "DELETE", {});
  }
);
